<template>
  <div>
    <!-- {{form}} -->
    <div class="header">
      <el-row type="flex" justify="space-between" align="middle">
        <div>
          <span class="title">预销计划</span>
          <select-year v-model="form.year" @change="handleYearChange"></select-year>
          <select-store v-model="form.storeId" @change="handleStoreChange"></select-store>
          <el-button type="text" @click="isShowCaption = true">预销功能说明</el-button>
        </div>
        <div class="right-section">
          <!-- <span class="refresh-time" v-if="refreshTime">刷新时间：{{ refreshTime }}</span> -->
          <el-button 
            type="primary" 
            size="small" 
            icon="el-icon-refresh" 
            :loading="refreshLoading"
            @click="handleRefresh">
            刷新
          </el-button>
          <el-link 
            type="primary" 
            v-permission="`ec-pc-new$advanceSalesManagement$preSalePlan$preSalePlan$Basic configuration`"
            @click="$router.push({name: 'Baseconfig'})">
            基础配置
          </el-link>
        </div>
      </el-row>
    </div>
    <caption-dialog :visible.sync="isShowCaption"></caption-dialog>
  </div>
</template>

<script>
import selectYear from './components/selectYear/selectYear'
import selectStore from './components/selectStore/selectStore'
import captionDialog from './components/captionDialog/captionDialog'

import mixin from '@/views/preSalePlan/utils/mixin.js'
export default {
  model: {
    prop: 'formData',
    event: 'input'
  },
  props: ['formData'],
  components: {
    selectYear, selectStore, captionDialog
  },
  data() {
    return {
      form: {},
      isShowCaption: false,
      refreshTime: '',
      refreshLoading: false
    }
  },
  created() {
    this.getRefreshTime();
  },
  watch: {
    formData: {
      handler (val) {
        this.form = {...val};
      },
      immediate: true,
      deep: true
    },
    form: {
      handler(val) {
        if(JSON.stringify(val) !== JSON.stringify(this.formData)) {
          this.$emit('input', val);
        }
      },
      deep: true
    }
  },
  methods: {
    handleYearChange(data) {
      this.$emit('change', {...this.form, year: data});
    },
    handleStoreChange(data) {
      this.$emit('change', {...this.form, storeId: data});
    },
    // 获取刷新时间
    getRefreshTime() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      this.refreshTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    // 刷新按钮点击
    handleRefresh() {
      this.refreshLoading = true;
      this.$q.preSalePlan.clearPrePlanCache()
      // 更新刷新时间
      this.getRefreshTime();
      // 触发父组件刷新方法
      this.$emit('refresh');
      // 延迟关闭loading状态，确保刷新动作完成
      setTimeout(() => {
        this.refreshLoading = false;
      }, 1000);
    }
  },
  mixins: [mixin]
}
</script>

<style lang="stylus" scoped>
  .header
    background #ffffff
    padding 10px
    border-radius 4px
  
  >>> .el-link.el-link--primary
    margin-left 15px

  .title
    font-size 14px
    font-weight bold
    color #555
    display inline-block
    margin-right 10px

  .right-section
    display flex
    align-items center

  .refresh-time
    font-size 12px
    color #999
    margin-right 5px
</style>